var moduleMap = {
	"./Reporte": () => {
		return Promise.all([__webpack_require__.e(734), __webpack_require__.e(611), __webpack_require__.e(636), __webpack_require__.e(631), __webpack_require__.e(621), __webpack_require__.e(258), __webpack_require__.e(801), __webpack_require__.e(120)]).then(() => (() => ((__webpack_require__(7459)))));
	},
	"./useReportePDF": () => {
		return Promise.all([__webpack_require__.e(611), __webpack_require__.e(258), __webpack_require__.e(607)]).then(() => (() => ((__webpack_require__(1607)))));
	},
	"./ReportActionBridge": () => {
		return __webpack_require__.e(439).then(() => (() => ((__webpack_require__(2439)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});